import Item from "./Item"

const ItemListContainer = (props) => {


    return (
        <>
            <section className="productos-lista"> 
                {props.items.map((producto) =>
                    <Item key={producto.id} id={producto.id} tipo={producto.tipo} nombre={producto.nombre} precio={producto.precio} img={producto.img} ingredientes={producto.ingredientes} />
                )}
            </section>
        </>
    )
}
//<div key={index}>{producto.nombre}</div>
export default ItemListContainer;